<script>
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import BasicInfoView from "@/components/members/basic-info-view";
  import memberDataClass from "../../datasets/MemberDataClass";

  export default {
    page: {
      title: "Member Details",
      meta: [{ name: "description", content: appConfig.description }]
    },

    components: { BasicInfoView, PageHeader},

    data() {
      return {
        title: "Member Details",
        member: new memberDataClass(),
        items: [
          {
            text: "Member ",
            href: "/visitors/home"
          },
          {
            text: "Details",
            active: true
          }
        ],
      };
    },
    methods: {

      fetch: function() {

        this.callAPI({
          endpoint: `/member/details`,
          type: 'get',
          successCallback: (response) => {
            this.member = response.data;
          }
        });
      },

      asyncFind (query) {
        this.isLoading = true

        this.callAPI({
          endpoint: `/missions/search`,
          type: 'post',
          data:{searchTerm:query},
          successCallback: (response) => {
            this.missions = response.data
            this.isLoading = false
          }
        });
      },

      flashImage: function() {
        this.$swal({
          imageUrl: this.member.profile_picture ?? 'https://dummyimage.com/150x150/F8F8FB/000000&text=User%20Image',
          showConfirmButton: false
        });
      }

    },
    created() {
      this.fetch();
    },

    beforeRouteLeave (to, from, next) {
      if(this.shouldSave)
      {
        const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
        if (answer) {
          next()
        } else {
          next(false)
        }
      }
      else {
        next()
      }
    }
  };
</script>

<template>
  <section class="my-5 pt-5">
    <div class="container">
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-4">
          <div class="card overflow-hidden">
            <div class="card-body">
              <div class="media">

                <img v-if="member.profile_picture!=null" :src="member.profile_picture" class="cu-pointer rounded-circle avatar-lg mr-2 mb-2 border-1" @click="flashImage">
                <img v-else
                     @click="flashImage"
                     src="https://dummyimage.com/150x150/F8F8FB/000000&text=User%20Image"
                     class="rounded-circle avatar-lg mr-2 mb-2 border-1">

                <div class="media-body">
                  <router-link tag="a" v-if="member.id" :to="{name: 'Member edit'}"
                               class="btn btn-sm btn-primary mr-1">
                    <i class="bx bx-edit mr-1"></i>
                    Edit
                  </router-link>
                </div>
              </div>

              <h5 class="font-size-15">{{member.fullname}}</h5>

              <p class="text-muted mb-0">{{member.occupation}}</p>
            </div>
          </div>
          <!-- end card -->

          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">
                <i class="bx bx-map mr-2"></i>
                Addresses
              </h4>
              <p v-if="member.addresses.length <= 0">
                No Addresses
              </p>
              <div v-for="address in member.addresses" :key="'ad-'+address.id">
                <small>
                  <i class="fa fa-location-arrow mr-1 mb-1"></i>
                  {{address.type}}
                </small>
                <p>
                  {{address.fulladdress}}
                </p>
                <hr>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body fixed-height scrollbar-indigo">
              <h4 class="card-title mb-4">
                <i class="mdi mdi-account-multiple-outline mr-2"></i>
                Related Members
              </h4>

              <ul class="list-group-flush pl-0" v-if="member.relationships.length >= 1">
                <li class="list-group-item" v-for="relation in member.relationships" :key="'rel-'+relation.id">
                  <span>
                    <i class="fa fa-address-card mr-2"></i>
                    {{relation.fullname}}
                  </span>
                  <br>
                  <small class="text-muted">({{relation.relation[1]}})</small>
                </li>
              </ul>

              <p v-else class="text-muted">
                No related members
              </p>
            </div>
          </div>

          <a href="/member/logout" class="mt-2 btn btn-block btn-danger d-none d-md-block">
            <i class="bx bx-log-out mr-2 font-size-15"></i>
            LOGOUT
          </a>

        </div>
        <div class="col-xl-8">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">
                <i class="bx bx-user mr-2"></i>
                Member Information
              </h4>
              <BasicInfoView :member="member"></BasicInfoView>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-md-8 col-sm-12">
                  <h4 class="card-title mb-4">
                    <i class="bx bx-briefcase mr-2"></i>
                    Affiliation with missions
                  </h4>
                </div>
              </div>

              <div class="table-responsive mb-0" v-if="member.missions.length > 0">
                <table class="table">
                  <thead>
                  <tr>
                    <th>#</th>
                    <th>Mission</th>
                    <th>Joined Date</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="mission in member.missions" :key="'mission-'+mission.id">
                    <td>
                      <div class="avatar-xs">
                        <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-16">
                          {{ mission.id }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <p>
                        {{mission.name}}<br>
                        <small>{{ _.get(mission,'pivot.role','-')}}</small>
                      </p>
                    </td>
                    <td>{{ _.get(mission,'pivot.joined_date','-')}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <p v-else class="p-5 text-center text-muted">
                No affiliation with any mission.
              </p>
            </div>
          </div>
          <a href="/member/logout" class="mt-2 btn btn-block btn-danger d-block d-md-none">
            <i class="bx bx-log-out mr-2 font-size-15"></i>
            LOGOUT
          </a>
        </div>

      </div>
    </div>
  </section>
</template>

<style scoped>
  .fixed-height {
    max-height: 250px; overflow-y: scroll;
  }
</style>
